// import { useMutation } from '@tanstack/react-query';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import authService from 'services/auth.service';
// import { useAuth } from 'contexts/AuthContext';

// export const useLogin = () => {
//   const navigate = useNavigate();
//   const { setUser } = useAuth();

//   return useMutation({
//     mutationFn: (credentials) => authService.login(credentials),
//     onSuccess: (data) => {
//       setUser(data?.user);
//       toast.success(`Welcome back, ${data.user.name}!`);
//       navigate('/admins', { replace: true });
//     },
//     onError: (error) => {
//       const errorMessage =
//         error.response?.data?.message ||
//         error.message ||
//         'Login failed. Please check your credentials.';
//       toast.error(errorMessage);
//     },
//   });
// };


import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import authService from 'services/auth.service';
import { useAuth } from 'contexts/AuthContext';

export const useLogin = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  return useMutation({
    mutationFn: (credentials) => authService.login(credentials),
    onSuccess: (data) => {
      setUser(data?.user);
      toast.success(`Welcome back, ${data.user.name}!`);

      const isAdmin = data?.user?.role?.name === 'admin';
      navigate(isAdmin ? '/executive-dashboard' : '/support-chat', { replace: true });
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Login failed. Please check your credentials.';
      toast.error(errorMessage);
    },
  });
};